// extracted by mini-css-extract-plugin
module.exports = {"root":"Tab_root__2vErU","container":"Tab_container__6VbyM","hidden":"Tab_hidden__2j68F"};